import { facebookPixelId, nodeEnv } from "../constants/config";

let ReactPixel: any = null;
let isInitialized = false;

/**
 * Initializes the Facebook Pixel with the config ID.
 * Safe to call on Gatsby client entry (onClientEntry).
 * Does NOT fire a PageView — onRouteUpdate handles that uniformly.
 */
export const initPixel = () => {
  if (typeof window === "undefined" || !facebookPixelId || isInitialized) return;

  import("react-facebook-pixel")
    .then((module) => {
      if (isInitialized) return;
      ReactPixel = module.default;
      ReactPixel.init(
        facebookPixelId,
        {},
        {
          autoConfig: true,
          debug: nodeEnv === "development",
        }
      );
      isInitialized = true;
      // PageView is intentionally NOT fired here.
      // onRouteUpdate fires immediately after onClientEntry and
      // calls trackPageView(), which records the first page visit exactly once.
    })
    .catch((err) => console.error("[Pixel] Failed to load react-facebook-pixel", err));
};

/**
 * Tracks a standard PageView event.
 * Called by onRouteUpdate on every client-side navigation.
 */
export const trackPageView = () => {
  if (typeof window === "undefined" || !facebookPixelId) return;

  if (isInitialized && ReactPixel) {
    ReactPixel.pageView();
    return;
  }

  // Pixel not yet initialized (e.g. module still loading) — initialize then track.
  import("react-facebook-pixel").then((module) => {
    ReactPixel = module.default;
    if (!isInitialized) {
      ReactPixel.init(facebookPixelId, {}, {
        autoConfig: true,
        debug: nodeEnv === "development",
      });
      isInitialized = true;
    }
    ReactPixel.pageView();
  }).catch((err) => console.error("[Pixel] trackPageView failed", err));
};

/**
 * Tracks a standard or custom Meta Pixel event (e.g. AddToCart, Purchase).
 * Ensures the pixel is always initialized before tracking.
 */
export const trackPixelEvent = (event: string, data?: Record<string, any>) => {
  if (typeof window === "undefined" || !facebookPixelId) return;

  if (isInitialized && ReactPixel) {
    ReactPixel.track(event, data);
    return;
  }

  // Pixel not yet initialized — initialize then track.
  import("react-facebook-pixel").then((module) => {
    ReactPixel = module.default;
    if (!isInitialized) {
      ReactPixel.init(facebookPixelId, {}, {
        autoConfig: true,
        debug: nodeEnv === "development",
      });
      isInitialized = true;
    }
    ReactPixel.track(event, data);
  }).catch((err) => console.error("[Pixel] trackPixelEvent failed", err));
};
